import Box from "@mui/material/Box";
import {ServerTableToolbarHostProvider} from "../../common/serverTable";
import {PropsWithChildren, useState} from "react";
import SettingsPageHeader from "./SettingsPageHeader";

type Props = PropsWithChildren<{
    title: string
    back: () => void
}>

const SettingsListPage = ({title, back, children}: Props) => {
    // The mobile header is the only band a list screen gets for free, so it doubles
    // as a landing place for table controls. It exists on mobile only, which is
    // exactly where hoisting applies — a list opts in with `hoistOnCompact`.
    const [toolbarHost, setToolbarHost] = useState<HTMLElement | null>(null)
    const [searchOverlayHost, setSearchOverlayHost] = useState<HTMLElement | null>(null)

    return (
        <ServerTableToolbarHostProvider host={toolbarHost} searchOverlayHost={searchOverlayHost}>
            <SettingsPageHeader
                title={title}
                back={back}
                actions={<Box ref={setToolbarHost} sx={{display: 'flex', alignItems: 'center'}}/>}
                overlay={(
                    <Box
                        ref={setSearchOverlayHost}
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            display: 'flex',
                            alignItems: 'center',
                            px: 1.5,
                            pointerEvents: 'none',
                        }}
                    />
                )}
                mobileOnly
            />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                    minWidth: 0,
                    minHeight: 0,
                }}
            >
                {children}
            </Box>
        </ServerTableToolbarHostProvider>
    )
}

export default SettingsListPage
